
import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const seoReactTableOfContents: TableOfContentsItem[] = [
  {
    id: "fundamentos-del-seo-en-react",
    title: "Fundamentos del SEO en React",
    subItems: [
      { id: "desafios-del-seo-en-aplicaciones-react", title: "Desafíos del SEO en aplicaciones React" }
    ]
  },
  {
    id: "importancia-del-renderizado-en-seo",
    title: "Importancia del renderizado en SEO",
    subItems: [
      { id: "renderizado-del-lado-del-servidor-ssr", title: "Renderizado del lado del servidor (SSR)" },
      { id: "generacion-de-contenido-estatico-ssg", title: "Generación de contenido estático (SSG)" },
      { id: "prerenderizado-en-aplicaciones-web", title: "Prerenderizado en aplicaciones web" }
    ]
  },
  {
    id: "estrategias-de-renderizado-para-react",
    title: "Estrategias de renderizado para React",
    subItems: [
      { id: "beneficios-del-ssr-en-seo", title: "Beneficios del SSR en SEO" },
      { id: "frameworks-para-ssr-en-react", title: "Frameworks para SSR en React" },
      { id: "ventajas-del-ssg", title: "Ventajas del SSG" },
      { id: "ejemplos-de-herramientas-para-ssg", title: "Ejemplos de herramientas para SSG" },
      { id: "uso-del-prerenderizado-para-seo", title: "Uso del prerenderizado para SEO" },
      { id: "limitaciones-del-prerenderizado", title: "Limitaciones del prerenderizado" }
    ]
  },
  {
    id: "optimizacion-del-archivo-html-en-react",
    title: "Optimización del archivo HTML en React",
    subItems: [
      { id: "uso-de-react-helmet-para-seo", title: "Uso de React Helmet para SEO" },
      { id: "modificacion-de-etiquetas-title", title: "Modificación de etiquetas title" },
      { id: "creacion-de-etiquetas-meta-personalizadas", title: "Creación de etiquetas meta personalizadas" },
      { id: "datos-estructurados-y-palabras-clave", title: "Datos estructurados y palabras clave" },
      { id: "implementacion-de-datos-estructurados", title: "Implementación de datos estructurados" },
      { id: "estrategia-de-palabras-clave-en-react", title: "Estrategia de palabras clave en React" }
    ]
  },
  {
    id: "mejora-de-la-experiencia-del-usuario-en-seo",
    title: "Mejora de la experiencia del usuario en SEO",
    subItems: [
      { id: "importancia-de-la-velocidad-de-carga", title: "Importancia de la velocidad de carga" },
      { id: "tecnicas-para-mejorar-tiempos-de-carga", title: "Técnicas para mejorar tiempos de carga" },
      { id: "herramientas-de-optimizacion", title: "Herramientas de optimización" },
      { id: "navegacion-y-urls-amigables", title: "Navegación y URLs amigables" },
      { id: "uso-de-react-router", title: "Uso de React Router" },
      { id: "evitar-urls-problematicas", title: "Evitar URLs problemáticas" }
    ]
  },
  {
    id: "supervision-y-ajustes-continuos",
    title: "Supervisión y ajustes continuos",
    subItems: [
      { id: "monitoreo-en-google-search-console", title: "Monitoreo en Google Search Console" },
      { id: "analisis-de-rendimientos-seo", title: "Análisis de rendimientos SEO" },
      { id: "identificacion-de-problemas-comunes", title: "Identificación de problemas comunes" },
      { id: "adaptacion-y-actualizacion-de-estrategias", title: "Adaptación y actualización de estrategias" },
      { id: "respuesta-a-cambios-en-algoritmos-de-busqueda", title: "Respuesta a cambios en algoritmos de búsqueda" },
      { id: "mejores-practicas-y-tendencias-actuales", title: "Mejores prácticas y tendencias actuales" }
    ]
  }
];
